import { createGlobalStyle } from 'styled-components'

export const ResetStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  button, link, input[type="submit"] {
    cursor: pointer;
  }

  body {
    font-family: 'Montserrat', sans-serif;
    background-color: ${(props) => props.theme.colors.black};
    height: 100vh; // fallback in case of browser incompatibility with svh units
    max-height: 100svh; // prevent overlap with dynamic ui components (e.g. safari searchbar)

    @media (max-width: 500px) {
      .scrollbar-thumb {
        width: 4px;
        height: 6px;
      }
      .scrollbar-track {
        background: transparent;
      }
    }
  }

  h1,
  h2,
  h3,
  h4,
  h5 {
    font-weight: ${(props) => props.theme.fontWeights.bold};
  }

  h1 {
    font-size: ${(props) => props.theme.fontSizes.h1};
    line-height: ${(props) => props.theme.lineHeight.h1};
    
  }

  h2 {
    font-size: ${(props) => props.theme.fontSizes.h2};
    line-height: ${(props) => props.theme.lineHeight.h2};
  }

  h3 {
    font-size: ${(props) => props.theme.fontSizes.h3};
    line-height: ${(props) => props.theme.lineHeight.h3};
  }

  h4 {
    font-size: ${(props) => props.theme.fontSizes.h4};
    line-height: ${(props) => props.theme.lineHeight.h4};
  }

  h5 {
    font-size: ${(props) => props.theme.fontSizes.h5};
    line-height: ${(props) => props.theme.lineHeight.h5};
  }
`
